module.exports = __webpack_public_path__ + "img/icon-small-arrow-up.4b128a17.svg";